module.exports = __webpack_public_path__ + "img/xuhongjie.cc734c74.jpg";